import React from 'react';
import { MARKETPLACE_OFFER_CAROUSEL } from 'types/morph.pagePosition.constants';
import { useSeenOfferPixel } from 'hook/helper.hook';
import { getViewOfferTileCard } from 'helpers/tracking.helpers';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import PIcon from 'components/personalization/PIcon';
import classnames from 'classnames';
import { Image } from 'components/Image/Image';
import Label from 'components/form/Label/Label';

const ImageOrIcon = props => {
  const { useImage, tileIconKey } = props;

  if (useImage) {
    return (
      <Image
        imgClass={`${tileIconKey}-dashboard`}
        className={'width60px height60px'}
      />
    );
  } else {
    return <PIcon icon={tileIconKey} />;
  }
};

const MarketplaceOfferCard = ({ offerModulePosition, ...props }) => {
  let attributes = {
    moduleName: MARKETPLACE_OFFER_CAROUSEL,
    modulePosition: props.modulePosition,
    offerModulePosition: offerModulePosition,
    cardName: props.cardName,
    vertical: props.verticalTracking,
    'Nav Location': props.location,
  };

  let trackingAttributes = getViewOfferTileCard(attributes);

  const seenOffer = useSeenOfferPixel(trackingAttributes);

  const offerCardStyle = classnames(
    'offer-card',
    'padTB16',
    'padLR8',
    'm-padLR8',
    props?.offerCardClass,
  );

  const descriptionStyle = classnames(
    'text-12',
    'margT16',
    'system_neutral_n400_text',
    'bold',
    props?.descriptionClass,
  );

  return (
    <div className={props.containerClasses}>
      <FlexContainer
        onClick={props.onLinkClickEvent}
        datatestid={`Overview-offer-carousel-link`}
        to={props.url}
        location={props.location}
        extraEventAttributes={trackingAttributes}
        ariaLabel={`${props?.text}`}
        tabIndex="0"
        role="region"
      >
        <div className={offerCardStyle}>
          <div className="FlexContainer flex-column justify-start items-align-center ">
            <div className="">
              <ImageOrIcon
                useImage={props?.useImage}
                tileIconKey={props?.tileIconKey}
              />
              {seenOffer}
            </div>
            <Label className={descriptionStyle} tabIndex="-1">
              {props.text}
            </Label>
          </div>
        </div>
      </FlexContainer>
    </div>
  );
};

export default MarketplaceOfferCard;
